import { v4 as uuidv4 } from 'uuid';
import { createComponentStore } from '../../utils/createComponentStore';

const generateOutputPlaceholderKey = () =>
  `external_action_${uuidv4().split('-')[0]}`;

const initData = () => ({
  selectedAppNameSlug: '',
  selectedAppName: '',
  selectedAppImgSrc: '',
  selectedActionKey: '',
  selectedActionVersion: '',
  configuredProps: {},
  dynamicPropsId: '',
  outputPlaceholderKey: generateOutputPlaceholderKey(),
});

const { getStore, defaultStore } = createComponentStore({
  type: 'perform_action_in_external_app',
  endpoint: 'perform_action_in_external_app',
  registryKey: 'perform_action_external',
  initData,

  extraState: () => ({
    selectedApp: {},
    selectedAction: {},
    appOptions: [],
    appActionOptions: [],
    actionsLoading: false,
  }),

  extraActions: (set, get) => ({
    setSelectedApp: (selectedApp) => set((s) => ({
      selectedApp,
      data: {
        ...s.data,
        selectedAppNameSlug: selectedApp?.nameSlug || '',
        selectedAppName: selectedApp?.name || '',
        selectedAppImgSrc: selectedApp?.imgSrc || '',
      },
    })),
    setAppOptions: (appOptions) => set({ appOptions: [...appOptions] }),
    setSelectedAction: (selectedAction) => set((s) => ({
      selectedAction,
      data: {
        ...s.data,
        selectedActionKey: typeof selectedAction === 'string'
          ? selectedAction
          : selectedAction?.key || '',
        selectedActionVersion: typeof selectedAction === 'string'
          ? s.data.selectedActionVersion
          : selectedAction?.version || '',
      },
    })),
    setAppActionOptions: (opts) => set({ appActionOptions: [...opts] }),
    setActionsLoading: (v) => set({ actionsLoading: v }),
    setConfiguredProps: (configuredProps) => set((s) => ({
      data: { ...s.data, configuredProps: { ...configuredProps } },
    })),
    setDynamicPropsId: (dynamicPropsId) => set((s) => ({
      data: { ...s.data, dynamicPropsId },
    })),
    setOutputPlaceholderKey: (outputPlaceholderKey) => set((s) => ({
      data: { ...s.data, outputPlaceholderKey },
    })),
  }),
});

export const getPerformActionExternalStore = getStore;
export default defaultStore;
